var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamrr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 10 10",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1 1h8M1 2h1m6 0h1M1 3h1m6 0h1M1 4h1m6 0h1M1 5h1m6 0h1M1 6h1m6 0h1M1 7h1m6 0h1M1 8h8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d18e6a",
    d: "M2 2h5M2 3h1M2 4h1M2 5h1M2 6h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bc345e",
    d: "M7 2h1M3 3h4M3 4h4M3 5h4M3 6h4M2 7h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#834c78",
    d: "M7 3h1M7 4h1M7 5h1M7 6h1M3 7h5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamrr);
export default __webpack_public_path__ + "static/media/teamrr.b7e9d50f798431785dedc1e00dc82d57.svg";
export { ForwardRef as ReactComponent };